enum ActionTypes {
  FETCH_LOCATION_SETTING_BOOKING_BY_MONTH = 'setting/FETCH_LOCATION_SETTING_BOOKING_BY_MONTH',
  FETCH_LOCATION_SETTING_BOOKING_SUCCESS = 'setting/FETCH_LOCATION_SETTING_BOOKING_SUCCESS',
  FETCH_LOCATION_SETTING_BOOKING_FAILURE = 'setting/FETCH_LOCATION_SETTING_BOOKING_FAILURE',
  UPDATE_LOCATION_SETTING_BOOKING = 'setting/UPDATE_LOCATION_SETTING_BOOKING',
}

export default ActionTypes;
